
import dayjs from "dayjs";
export default {
  props: {
    info: String,
    data: String,
  },

  filters: {
    data(date) {
      return dayjs(date).format("DD/MM/YYYY HH:mm");
    },
  },
};
